// extracted by mini-css-extract-plugin
export default {"buttonCopy":"ButtonCopy_buttonCopy__WXPmu"};